import { render, staticRenderFns } from "./InformationForm.vue?vue&type=template&id=ee0baf8e"
import script from "./InformationForm.vue?vue&type=script&lang=ts"
export * from "./InformationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports